module.exports = __webpack_public_path__ + "img/CAST证书_01.c1966091.png";